module.exports = __webpack_public_path__ + "img/logo.df8afb32.png";